import { useMutation } from "@tanstack/react-query";
import { trainerAccountApi } from "api/trainers/trainerAccountApi";

export const useSendTrainerInvite = (trainerId: number) => {
  return useMutation({
    mutationFn: () => trainerAccountApi.sendInvite(trainerId),
  });
};
